import { Endpoint } from "../config";

export type ProfileEndpointType =
  | "profile"
  | "updateProfile"
  | "changeprofilepassword"
  | "updateLog"
  | "languageMe";

export const profileEndpoints: Record<ProfileEndpointType, Endpoint> = {
  profile: {
    url: "organization/me/",
  },
  updateProfile: {
    url: "organization/me/",
  },
  updateLog:{
    url: "organization/me/",
  },
  changeprofilepassword: {
    url: "me/change-password/",
  },
  languageMe: {
    url: "language/me/",
  },
};
